import React from 'react';
import { motion } from 'framer-motion';
const BOOK_COVER_URL = 'https://cdn.magicpatterns.com/uploads/4bvjKmWZd3NtvDruvwvV8w/Portada_para_el_E-book_Por_que_Levantar_tu_autoestima_en_Epocas_de_Crisis.-.png';
export function HeroSection() {
  return <section className="relative w-full min-h-screen flex items-center overflow-hidden bg-warm-dark" data-id="element-82">
      {/* Subtle radial gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-warm-darker/50 via-transparent to-warm-dark pointer-events-none" data-id="element-83" />
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-amber/5 rounded-full blur-[120px] pointer-events-none" data-id="element-84" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-sunset/5 rounded-full blur-[100px] pointer-events-none" data-id="element-85" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 w-full" data-id="element-86">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-87">
          {/* Text content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-88">
            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} className="text-amber font-body text-sm sm:text-base uppercase tracking-[0.2em] mb-6" data-id="element-89">
              Guía práctica de bienestar
            </motion.p>

            <h1 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] xl:text-[3.5rem] leading-[1.15] font-bold text-cream mb-6" data-id="element-90">
              ¿Cómo Elevar Tu Autoestima y Recuperar Tu Confianza{' '}
              <span className="text-amber italic" data-id="element-91">en Medio del Caos?</span>
            </h1>

            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} className="font-body text-cream-muted/80 text-base sm:text-lg md:text-xl leading-relaxed mb-10 max-w-xl mx-auto lg:mx-0" data-id="element-92">
              Descubre la guía práctica para combatir el estrés, la ansiedad y
              la depresión, paso a paso.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.7,
            duration: 0.6
          }} data-id="element-93">
              <a href="https://www.equilibriopersonalhoy.com/cart/46514378342558:1" className="inline-block font-body font-semibold text-warm-dark bg-amber hover:bg-amber-light px-8 py-4 rounded-lg text-base sm:text-lg transition-all duration-300 hover:shadow-amber-glow active:scale-[0.97]" data-id="element-94">
                ¡Quiero Mi Guía Ahora!
              </a>
            </motion.div>
          </motion.div>

          {/* Book cover */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.9,
          ease: 'easeOut'
        }} className="flex justify-center lg:justify-end" data-id="element-95">
            <motion.div animate={{
            y: [0, -12, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-96">
              <img src={BOOK_COVER_URL} alt="Portada del eBook: Por qué Levantar tu Autoestima en Épocas de Crisis" className="w-[280px] sm:w-[340px] md:w-[380px] lg:w-[420px] rounded-lg shadow-book" data-id="element-97" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}